const buildQueryString = (params: Record<string, string>): string => {
  console.log('path params', params);
  return (
    '?' +
    Object.entries(params)
      .map(([key, value]) => `${key}=${value}`)
      .join('&')
  );
};
export default buildQueryString;
